import { Action } from "redux";
import { FilterCondition } from "../../../types";
import { FeatureCollection } from "geojson";

export const SAVE_WFS_3D_LAYERS = "SAVE_WFS_3D_LAYERS";

export interface SaveWfs3dLayerAction extends Action {
    features: FeatureCollection;
    layerGroup: string;
    layerName: string;
    filters?: FilterCondition[];
    featureShortName: string;
}

export const saveWfs3dLayerAction = (
    features: FeatureCollection,
    layerGroup: string,
    layerName: string,
    featureShortName: string,
    filters?: FilterCondition[]
): SaveWfs3dLayerAction => {
    return {
        type: SAVE_WFS_3D_LAYERS,
        features: features,
        layerGroup: layerGroup,
        layerName: layerName,
        featureShortName: featureShortName,
        filters: filters,
    };
};
